import * as Yup from 'yup';

export const TextUsNowFormValidationSchema = () =>
    Yup.object({
        call_to_action_text: Yup.string().required('Please enter the call to action text.'),
        twilio_id: Yup.string()
            .nullable()
            .required('Please select a Twilio phone number.')
    });
